import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';
import { EDIT_SELECTED_IMPUTHOUR, SHOW_NOTIFICATION } from '../constants';
import { ROLES } from '../constants/permissions';

// Middleware para comprobar acciones de edición de imputación de horas
const imputHoursMiddleware = store => next => action => {
  // Interceptar acción de editar imputación
  if (action.type === EDIT_SELECTED_IMPUTHOUR && action.payload) {
    const state = store.getState();
    const currentUserId = state.profile?._id || state.profile?.id;
    const isAdmin = state.profile?.role === ROLES.admin.role;

    // Verificar si la imputación pertenece al usuario actual (los administradores pueden editar cualquiera)
    if (action.payload.user && action.payload.user !== currentUserId && !isAdmin) {
      // Si no pertenece al usuario actual, mostrar error y no propagar la acción
      store.dispatch({
        type: SHOW_NOTIFICATION,
        payload: {
          show: true,
          status: "error",
          message: "No puedes modificar imputaciones de otros usuarios",
        },
      });
      
      // No propagar la acción original
      return;
    }
  }
  
  // Si no es interceptada o pasa la validación, continuar con la acción
  return next(action);
};

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware()
      .concat(imputHoursMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});
